export const MENU_STATUS_OPTIONS = [
  { value: "", label: "Tất cả" },
  { id: 1, value: 1, label: "Mới tạo" },
  { id: 2, value: 2, label: "Áp dụng" },
  { id: 3, value: 3, label: "Ngưng" },
];

export const WEEKDAYS_OPTIONS = [
  { id: 1, value: 1, label: "Thứ 2" },
  { id: 2, value: 2, label: "Thứ 3" },
  { id: 3, value: 3, label: "Thứ 4" },
  { id: 4, value: 4, label: "Thứ 5" },
  { id: 5, value: 5, label: "Thứ 6" },
  { id: 6, value: 6, label: "Thứ 7" },
  { id: 7, value: 7, label: "Chủ nhật" },
];

export const WEEKDAYS = {
  1: "Thứ 2",
  2: "Thứ 3",
  3: "Thứ 4",
  4: "Thứ 5",
  5: "Thứ 6",
  6: "Thứ 7",
  7: "Chủ nhật",
};

export const PRICE_TYPES_OPTIONS = [
  { value: "normal", label: "Giá bán ngày thường" },
  { value: "holiday", label: "Giá bán ngày lễ" },
];
